import { useQuery } from '@apollo/react-hooks';
import { GET_ALL_ECHELONS, GET_ECHELON } from '../../graphql/echelon/query';
import {
  GetAllEchelons,
  GetAllEchelonsVariables,
} from '../../graphql/echelon/types/GetAllEchelons';
import {
  GetEchelon,
  GetEchelonVariables,
} from '../../graphql/echelon/types/GetEchelon';

export const useGetAllEchelons = () => {
  return useQuery<GetAllEchelons, GetAllEchelonsVariables>(GET_ALL_ECHELONS);
};

export const useGetEchelon = (variables: GetEchelonVariables) => {
  return useQuery<GetEchelon, GetEchelonVariables>(GET_ECHELON, {
    variables,
    onError: (error) => console.log(error),
  });
};
